import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PhproductstatusEditForm from './PhproductstatusEditForm';
import PhproductstatusList from './PhproductstatusList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PhproductstatusListView from './PhproductstatusListView'


export default function PhproductstatusDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.phproductstatusDashboard);
  const [ phproductstatusId, setPhproductstatusId] = React.useState('');
  const [reloadPhproductstatusList, setReloadPhproductstatusList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PhproductstatusEditForm 
            setReloadPhproductstatusList={setReloadPhproductstatusList}
            phproductstatusId={phproductstatusId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PhproductstatusListView 
                      setPhproductstatusId = {setPhproductstatusId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
